import FetchCall from  '../shared/local_fetch_call'

let roomcashNavDiv = document.getElementById('roomcashAmount')

if (roomcashNavDiv){
  FetchCall.fetchWithoutLocale(
    '/roomcash_amounts.json',
    'GET',
    null).then(res => {
    roomcashNavDiv.innerText = res['roomcash_points']
  })

}
